import TTimePicker from './index.vue'

TTimePicker.install = Vue => {
  Vue.component(TTimePicker.name, TTimePicker)
}

export default TTimePicker



// WEBPACK FOOTER //
// ./src/module/time-picker/index.js